export default "__VITE_ASSET__CAvG4uBA__"